import { Component, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LoginService } from '../../../services/login.service';

@Component({
  selector: 'ness-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnDestroy  {
  bannerMessages: string = environment.bannerMessages;

  private _destroyed$: Subject<void> = new Subject<void>();
  private _loggedIn: boolean = false;
  get loggedIn(): boolean {
    return this._loggedIn;
  }

  constructor(private loginService: LoginService) {
    this.loginService.userInfoData$.pipe(takeUntil(this._destroyed$)).subscribe(
      (userInfo: ServerModels.UserInfoViewModel) => this._loggedIn = !!userInfo
    );
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
